import { createApp } from 'vue'
import Popper from 'vue3-popper';
import { createStore } from 'vuex';

import App from './App.vue'
import FileManager from 'laravel-file-manager'
import router from './router'
import market from './store'

const store = createStore(market);

import Notifications from '@kyvg/vue3-notification'

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VCalendar from 'v-calendar';
import './assets/v-select.css';
import i18n from './plugin/i18n'

const translate = new i18n({store});

const formatter = new Intl.NumberFormat();

const app                            = createApp(App);
app.config.globalProperties.$filters = {
  money(value) {
    if (typeof value !== 'number') {
      if (!value) {
        return '0'
      }
      return value;
    }
    return formatter.format(value);
  },
  backgroundImage(image) {
    if (!image) {return image}
    if (image?.url){
      if (image.url.includes(".mp4")) {
        return 'url(images/mp4.png)';
      }
      if (image.url.includes(".webm")) {
        return 'url(images/webm.png)';
      }
      if (image.url.includes(".ogg")) {
        return 'url(images/ogg.png)';
      }
    }
    if (image.includes('https://')) {
      return 'url("' + image + '")'
    }
    return image ? 'url("' + `${window.location.protocol}//${window.location.host}${image}` + '")' : ''
  }
};

app
  .use(Notifications)
  .use(VCalendar, {})
  .use(translate)
  .component('v-select', vSelect)
  .component('Popper', Popper)
  .use(router)
  .use(store)
  .use(FileManager, {store})
  .mount('#app');
